import { EmailToUserConstants } from "../constants/emailtouser.constants";

const EmailToUsersReducer = (state, action) => {
  switch (action.type) {
    case EmailToUserConstants.FETCH_EMAILTOUSER_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case EmailToUserConstants.FETCH_EMAILTOUSER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        emailToUsers: action.payload.data,
        paging: action.payload.paging,
      };
    case EmailToUserConstants.FETCH_EMAILTOUSER_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case EmailToUserConstants.EMAILTOUSER_SEARCH_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case EmailToUserConstants.EMAILTOUSER_SEARCH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        emailToUserSearchResults: action.payload,
      };
    case EmailToUserConstants.EMAILTOUSER_SEARCH_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case EmailToUserConstants.EMAILTOUSER_AUTO_SEARCH_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case EmailToUserConstants.EMAILTOUSER_AUTO_SEARCH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        emailToUserAutoSearchResults: action.payload,
      };
    case EmailToUserConstants.EMAILTOUSER_AUTO_SEARCH_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case EmailToUserConstants.GET_EMAILTOUSER_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case EmailToUserConstants.GET_EMAILTOUSER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        emailToUser: action.payload,
      };
    case EmailToUserConstants.GET_EMAILTOUSER_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case EmailToUserConstants.DOWNLOAD_EMAILTOUSER_REQUEST:
      console.log("action33333333", action.payload);
      return {
        ...state,
        isLoadingDownload: true,
        hasError: false,
        downloadFileType: action.payload.fileType,
      };
    case EmailToUserConstants.DOWNLOAD_EMAILTOUSER_SUCCESS:
      return {
        ...state,
        isLoadingDownload: false,
        downloadFileType: "",
      };
    case EmailToUserConstants.DOWNLOAD_EMAILTOUSER_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoadingDownload: false,
        downloadFileType: "",
      };

    default:
      return state;
  }
};

export default EmailToUsersReducer;
